// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2q8OK","content":"styles_content__QrNAt","row":"styles_row__1wKvo","footer":"styles_footer__2Fod8","phraseLength":"styles_phraseLength__6z6fo"};